export const predefinableMetricNames = ['TEMPERATURE', 'PH', 'PRESSURE']

export const addFormMetricNames = ['VELOCITY', 'TEMPERATURE', 'PRESSURE'];
export const centrifugationFormMetricNames = ['SPEED', 'TEMPERATURE', 'PRESSURE'];
export const removeFormMetricNames = ['TEMPERATURE', 'PRESSURE']

export const conditionFormMetricNames = ['TEMPERATURE', 'PH', 'PRESSURE', 'IRRADIATION', 'MOTION', 'EQUIPMENT']

export const amountInputSetMetricNames = ['VOLUME', 'WEIGHT', 'MOLAR']
